import React, { Fragment, Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Paper from '@material-ui/core/Paper'
import CKEditor from 'react-ckeditor-component'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import { ckeditorDocumentConfig, ckeditorScript } from '../../utils'
import { connect } from 'react-redux'
import { contentActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import HtmlLinkDialog from '../../components/HtmlLinkDialog'

const styles = theme => ({
  formGroup: {
    padding: '12px 0'
  },
  formControl: {
    margin: '14px 0'
  },
  wrapper: {
    minWidth: '90vh'
  },
  ckeditor: {
    height: '100%'
  },
  linkToolbar: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    padding: '8px 0'
  }
})

const CustomDialog = withStyles(theme => ({
  paper: {
    width: '85vw',
    maxWidth: '100%',
    minWidth: 0,
    height: '90vh',
    minHeight: 0
  }
}))(Dialog)

class EditDocumentModal extends Component {
  constructor(props) {
    super(props)
    this.didRemoveAllTabIndexes = false
    this.intervalKey = undefined
    this.state = {
      newHTMLContent: `${this.props.content.conteudoHtml || ''}`,
      linkDialogOpen: false,
      linkInitial: null
    }
  }

  applyNewContent = () => {
    const { newHTMLContent } = this.state

    this.props.handleChangeContent({
      ...this.props.content,
      contentPreview: newHTMLContent,
      conteudoHtml: newHTMLContent
    })
    this.props.onClose()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.open && this.props.open !== newProps.open) {
      this.setState({ linkDialogOpen: false, linkInitial: null })
      if (!this.didRemoveAllTabIndexes) {
        this.intervalKey = setInterval(() => {
          this.removeAllTabIndexes()
        }, 0)
      }
    } else {
      this.didRemoveAllTabIndexes = false
      this.intervalKey = undefined
    }
  }

  removeAllTabIndexes() {
    const $editDocumentModal = document.getElementById('conteudos-editor-documento')

    if ($editDocumentModal) {
      const $allDivs = $editDocumentModal.querySelectorAll('div')

      for (let $div of $allDivs) {
        $div.removeAttribute('tabindex')
      }

      this.didRemoveAllTabIndexes = true
      clearInterval(this.intervalKey)
    }
  }

  handleOpenLink = type => {
    let text = ''
    let url = ''
    let contentId = ''
    this.selectedEditorLink = null

    if (this.editor) {
      const selection = this.editor.getSelection()
      const startElement = selection && selection.getStartElement()
      const link =
        startElement && startElement.getName() === 'a'
          ? startElement
          : startElement && startElement.getAscendant('a', true)

      text = (selection && selection.getSelectedText()) || (link && link.getText()) || ''
      url = (link && link.getAttribute('href')) || ''
      contentId = (link && link.getAttribute('data-href')) || ''
      this.selectedEditorLink = link || null
    }

    this.setState({
      linkDialogOpen: true,
      linkInitial: {
        type,
        text,
        url: type === 'external' && url !== '#' ? url : '',
        contentId: type === 'internal' ? contentId : ''
      }
    })
  }

  handleApplyLink = html => {
    if (!this.editor) return

    const selection = this.editor.getSelection()
    if (this.selectedEditorLink && selection) {
      selection.selectElement(this.selectedEditorLink)
    }
    this.editor.insertHtml(html)
    this.setState({
      newHTMLContent: this.editor.getData(),
      linkDialogOpen: false
    })
  }

  render() {
    const { onClose, open = false, classes, content } = this.props
    const { newHTMLContent } = this.state

    return (
      <div>
        <CustomDialog
          modalId="conteudos-editor-documento"
          modalParams={{ registro: content._id, tipo: content.tipo }}
          open={open}
          onClose={onClose}
          className={classes.dialogWrapper}
        >
          <Fragment>
            <DialogTitle id="conteudos-editor-documento-title">
              Conteúdos — Editor do documento
            </DialogTitle>
            <DialogContent>
              <Paper className={classes.wrapper} elevation={4}>
                <div className={classes.formControl}>
                  <div className={classes.linkToolbar}>
                    <Button variant="outlined" onClick={() => this.handleOpenLink('external')}>
                      Link externo
                    </Button>
                    <Button variant="outlined" onClick={() => this.handleOpenLink('internal')}>
                      Link interno do Informed
                    </Button>
                  </div>
                  <CKEditor
                    id="field-detalhes-aula"
                    content={newHTMLContent}
                    config={ckeditorDocumentConfig}
                    scriptUrl={ckeditorScript}
                    events={{
                      instanceReady: event => {
                        this.editor = event.editor
                      },
                      change: event => {
                        const data = event.editor.getData()
                        this.setState({ newHTMLContent: data })
                      }
                    }}
                  />
                </div>
              </Paper>
            </DialogContent>
            <DialogActions>
              <Button color="outline" onClick={onClose}>
                Fechar
              </Button>
              <Button color="primary" variant="raised" onClick={() => this.applyNewContent()}>
                Aplicar edição
              </Button>
            </DialogActions>
            <HtmlLinkDialog
              modalId="conteudos-editor-documento-link"
              open={this.state.linkDialogOpen}
              initial={this.state.linkInitial}
              onClose={() => this.setState({ linkDialogOpen: false })}
              onApply={this.handleApplyLink}
            />
          </Fragment>
        </CustomDialog>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    open: state.content.openEditDocumentModal
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onClose: () => {
      dispatch(contentActions.closeEditDocumentModal())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditDocumentModal)))



// WEBPACK FOOTER //
// ./src/containers/Content/EditDocumentModal.js